module.exports = __webpack_public_path__ + "img/pro_2.427841ba.png";